/* src/app/views/admin/patient-profile/patient-profile.component.css */
/*# sourceMappingURL=patient-profile.component.css.map */
